var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jds-sheet',[_vm._v(" Hello, candidate! "),_c('jds-toolbar',[_c('jds-button',{attrs:{"to":{name: 'playground.jobs.single.candidates'}}},[_vm._v(" Back ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }